export type ReactionsCount = {
  LIKE?: number
}

export type CommentReactionProps = {
  commentId: number
  openInputAnswer: boolean
  canUserRespondToComment?: boolean
  reactionsCount?: ReactionsCount
  parentCommentId?: number
  userReaction?: string
  setOpenInputAnswer: (value: boolean) => void
  onSuccess?: () => void
}

export enum ReactionType {
  LIKE = 'LIKE'
}
